import React from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from 'react-animate-on-scroll';


const BannerChicoRegistroBoletos = () => {
    return (
        <div className="slider-area banner-style-chico-educacion ">
            <div className="wrapper d-flex align-items-center home-four-banner-wrapper">
                <div className="container eduvibe-animated-shape">

                    <div className="row g-5 align-items-center">
                        <div className="col-lg-2 order-2 order-lg-1" />
                        <div className="col-lg-8 order-2 order-lg-1">
                            <div className="inner mt_md--10 mt_sm--10">
                                <div className="content text-center">
                                    <h1 className="title">Registro de boletos</h1>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 order-2 order-lg-1" />
                    </div>
                </div>

            </div>
        </div>



    )
}

export default BannerChicoRegistroBoletos;



